import type { NavItem, TabConfig } from './nav-types'
import { flatNavigationConfig } from './nav-flat'

export type { NavDomainGroup, NavItem, NavGroup, TabConfig } from './nav-types'
export { flatNavigationConfig } from './nav-flat'

export const getNavItemByHref = (href: string): NavItem | null => {
  for (const item of flatNavigationConfig) {
    if (item.href === href) return item
    if (item.children) {
      for (const child of item.children) {
        if (child.href === href) return child
      }
    }
    if (item.tabItems) {
      for (const tab of item.tabItems) {
        if (tab.href === href) return tab
      }
    }
  }
  return null
}

export const getTabConfigForPath = (currentPath: string): TabConfig | null => {
  for (const item of flatNavigationConfig) {
    if (item.hasTabs && item.tabItems) {
      const directHit = item.tabItems.find(tab =>
        currentPath === tab.href || currentPath.startsWith(tab.href + '/')
      )
      // Group-root fallback: parent's href is a prefix of currentPath but no
      // leaf tab.href is. Commander Bridge IA uses this — each tab.href is the
      // group's default leaf (/atc/bridge/operations/manifest), but a sibling
      // sub-route (/atc/bridge/operations/escalations) must still pin the
      // outer tab strip. Also matches the bare root (/atc/bridge) so the
      // strip renders even before a leaf is selected.
      const groupRootHit = !directHit && item.href && (
        currentPath === item.href || currentPath.startsWith(item.href + '/')
      )
        ? item.tabItems[0]
        : null
      if (directHit || groupRootHit) {
        return {
          groupId: item.id,
          groupLabel: item.labelKey,
          tabs: item.tabItems.sort((a, b) => (a.tabOrder || 0) - (b.tabOrder || 0)),
          defaultTab: item.tabItems[0]?.href,
        }
      }
    }
  }
  return null
}

export const getTabGroupForPath = (currentPath: string): string | null => {
  const tabConfig = getTabConfigForPath(currentPath)
  return tabConfig?.groupId || null
}

export const getActiveTabForPath = (currentPath: string): NavItem | null => {
  const tabConfig = getTabConfigForPath(currentPath)
  if (!tabConfig) return null
  return tabConfig.tabs.find(tab =>
    currentPath === tab.href || currentPath.startsWith(tab.href + '/')
  ) || null
}
